import IService from 'core/service/IService';
import ConfigUtil from 'core/util/config/ConfigUtil';
import { IRegisterOptions } from 'core/util/ServiceRegistry';
import UnauthorizedException from "../../util/exception/UnauthorizedException";
import TokenSession from "../../util/session/TokenSession";

export enum CachingPolicy {
	NONE,
	MODERATE,
	AGGRESSIVE
}

/*
export class ResolverRegisterOptions implements IRegisterOptions {
	public publicId?: string;

	public cachingPolicy: CachingPolicy;

	constructor(cachingPolicy: CachingPolicy) {
		this.cachingPolicy = cachingPolicy;
	}

	public static NONE = new ResolverRegisterOptions(CachingPolicy.NONE);
} */

export type QueryFunction = (params: object) => string;

export default abstract class IResolverService implements IService {
	private static CONFIG_FIELD: string = "service.resolver";
	private static REGISTRY: string = "api:resolver";

	public getRegistry(): string {
		return IResolverService.REGISTRY;
	}

	public getActive(): string {
		return ConfigUtil.getString(IResolverService.CONFIG_FIELD);
	}

	public getConditions() { return undefined; }

	public abstract clearCache(): Promise<any>;

	public abstract execute(query: string | QueryFunction, params?: object): Promise<any>;

	public abstract getServiceId(): string;

	protected static validateResponse(response: Promise<any>): Promise<any> {

		// if the response contains an unautorized error, the token may have expired.
		// Redirect to the gateway to get a new one

		// TokenSession.refresh();

		return response.catch((r) => {

			throw new UnauthorizedException("Resolver recieved http unauthorized response. Token missing or expired?", r);

		});
	}
}



// WEBPACK FOOTER //
// ./src/core/service/resolver/IResolverService.ts